/**
 * Biopet Professional — aliases to personal overlay helpers.
 * Source remains compatible with previous essential config.
 */
import {
  personalOverlayConfigBiopetEssential as personalOverlayConfigBiopetEssentialBase,
  formatBiopetOverlayDisplayValue as formatBiopetOverlayDisplayValueBase,
  petAgeYearsToLifeStageLabel as petAgeYearsToLifeStageLabelBase,
  petHealthRawFromRow as petHealthRawFromRowBase,
  petHealthCsvDisplay as petHealthCsvDisplayBase
} from '../biopet_essential/Config_personal_biopet_essential';

export const personalOverlayConfigBiopetProfessional = personalOverlayConfigBiopetEssentialBase;
export const formatBiopetProfessionalOverlayDisplayValue = formatBiopetOverlayDisplayValueBase;
export const petProfessionalAgeYearsToLifeStageLabel = petAgeYearsToLifeStageLabelBase;
export const petProfessionalHealthRawFromRow = petHealthRawFromRowBase;
export const petProfessionalHealthCsvDisplay = petHealthCsvDisplayBase;

// Backward-compatible aliases
export const personalOverlayConfigBiopetEssential = personalOverlayConfigBiopetProfessional;
export const formatBiopetOverlayDisplayValue = formatBiopetProfessionalOverlayDisplayValue;
export const petAgeYearsToLifeStageLabel = petProfessionalAgeYearsToLifeStageLabel;
export const petHealthRawFromRow = petProfessionalHealthRawFromRow;
export const petHealthCsvDisplay = petProfessionalHealthCsvDisplay;
